'use strict';

function CnTranspireController($q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.onFormSubmit = onFormSubmit;
  vm.onFormChange = onFormChange;
  vm._onFormReset = _onFormReset;

  function $onInit() {
    vm.onSubmit = vm.onSubmit() || $q.resolve;
    vm.onChange = vm.onChange() || function() {};
    vm.transpire = new Date().toISOString();
    vm.onFormChange();
  }

  function _onFormReset() {
    vm.form.$setPristine();
    vm.form.$setUntouched();
  }

  function onFormSubmit() {
    vm.onSubmit(vm.transpire).finally(vm._onFormReset);
  }

  function onFormChange() {
    vm.onChange(vm.transpire);
  }
}

module.exports = CnTranspireController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-transpire-form/cn-transpire-form.controller.js
 ** module id = 95
 ** module chunks = 0
 **/